import { render, staticRenderFns } from "./addBank.vue?vue&type=template&id=052f9105&scoped=true&"
import script from "./addBank.vue?vue&type=script&lang=js&"
export * from "./addBank.vue?vue&type=script&lang=js&"
import style0 from "./addBank.vue?vue&type=style&index=0&id=052f9105&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f9105",
  null
  
)

export default component.exports